// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nnL2oJAVAJRqDMvkTo9-2g\\=\\={cursor:pointer}.nnL2oJAVAJRqDMvkTo9-2g\\=\\= .hidden,.nnL2oJAVAJRqDMvkTo9-2g\\=\\=.hidden{display:none}", "",{"version":3,"sources":["webpack://client_react/src/components/GoToEmburse/GoToEmburse.styl"],"names":[],"mappings":"AAEA,4BACE,cAAQ,CAER,uEAEE,YAAS","sourcesContent":["@import '../../../../client/styles/vars';\n\n:local(.global) {\n  cursor: pointer;\n\n  .hidden,\n  &.hidden {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"global": "nnL2oJAVAJRqDMvkTo9-2g=="
};
module.exports = ___CSS_LOADER_EXPORT___;
